import { createContext } from "react";

const DF_CO0002Context = createContext();

export {DF_CO0002Context}